// Copyright 2023 Amazon.com, Inc. or its affiliates. All Rights Reserved.

import React from "react";
import { Link, SpaceBetween } from "@cloudscape-design/components";
import { useTranslation } from "react-i18next";
import { cookieManagerInstance } from "../../../cookies";
import moment from "moment";
import "./style.css";
import { useBreakpoint } from "@amzn/aws-euc-ui";
import { AwsIcon } from "../../icon";
import { CustomColorThemeDiv } from "../../general/CustomColorTheme/CustomColorTheme";
import { getCustomBrandingConfig } from "../../../utils/configurationUtils";

const Footer = () => {
    const { t } = useTranslation();
    const { isDesktopOrLaptop } = useBreakpoint();
    const customBrandingConfig = getCustomBrandingConfig();

    return (
        <CustomColorThemeDiv
            additionalClassNames={["euc-footer-outer-container-style"]}
        >
            <div className="euc-footer-inner-container-style">
                <div className="euc-footer-container-style">
                    {!customBrandingConfig?.userSettingId && (
                        <Link
                            href="https://aws.amazon.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            ariaLabel={t("euc.signIn.footer.aws.link.label")}
                        >
                            <AwsIcon />
                        </Link>
                    )}
                    <Link
                        href="https://aws.amazon.com/privacy/"
                        variant="info"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="euc-footer-first-link-style">
                            {t("euc.signIn.footer.privacyPolicy.label")}
                        </span>
                    </Link>
                    <Link
                        href="https://aws.amazon.com/terms/"
                        variant="info"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="euc-footer-link euc-footer-text">
                            {t("euc.signIn.footer.terms.label")}
                        </span>
                    </Link>
                    <Link
                        onFollow={cookieManagerInstance.customizeCookies}
                        variant="info"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="euc-footer-link euc-footer-text">
                            {t("euc.signIn.footer.cookiePreferences.label")}
                        </span>
                    </Link>
                    <Link
                        href={`${process.env.PUBLIC_URL}/LICENSE-THIRD-PARTY.txt`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="euc-footer-last-link-style">
                            {t("login.openSourceAttributions.link")}
                        </span>
                    </Link>
                </div>
                {!isDesktopOrLaptop && (
                    <div className="euc-footer-copy-right-container-style">
                        <span className="euc-footer-span-style">
                            &copy;{" "}
                            {`${moment("01/01/2008").format(
                                "YYYY"
                            )} - ${moment().format("YYYY")}`}{" "}
                            {t("euc.signIn.brandedFooter.awsAffiliates.label")}{" "}
                            {t(
                                "euc.signIn.brandedFooter.allRightsReserved.label"
                            )}
                        </span>
                    </div>
                )}
                {customBrandingConfig?.userSettingId && (
                    <SpaceBetween size="xxs" direction="horizontal">
                        <span className="euc-footer-text powered-by custom-branding">
                            Powered by
                        </span>
                        <div className="powered-by-logo">
                            <Link
                                href="https://aws.amazon.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                ariaLabel={t(
                                    "euc.signIn.footer.aws.link.label"
                                )}
                            >
                                <AwsIcon
                                    color={customBrandingConfig?.colorTheme}
                                />
                            </Link>
                        </div>
                    </SpaceBetween>
                )}
            </div>
        </CustomColorThemeDiv>
    );
};

export default Footer;
